module.exports = __webpack_public_path__ + "img/logo1.7230ef99.png";